import script from "./SaleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleForm.vue?vue&type=script&setup=true&lang=js"

import "./SaleForm.vue?vue&type=style&index=0&id=6c3b1e15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c3b1e15"]])

export default __exports__